export default __webpack_public_path__ + "static/media/Facial_Hair_preview.e48929f8.gif";